import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "connect container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h2 class=\"connect__title title\">Подключиться</h2><div class=\"connect__content\"><p class=\"connect__desc\"> Хотите начать пользоваться системой? Напишите нам. </p><div class=\"connect__mail mail\"><h4 class=\"mail__title\">email</h4><span class=\"mail__value\">hello@everypay.io </span></div></div>", 2)
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<label for=\"\" class=\"form__label\"><input type=\"text\" placeholder=\"Ваше имя*\" class=\"form__input\"></label><label for=\"\" class=\"form__label\"><input type=\"email\" placeholder=\"Email*\" class=\"form__input\"></label><textarea class=\"form__input form__textarea\" name=\"\" id=\"\" placeholder=\"Расскажите о своей компании*\" cols=\"30\" rows=\"10\"></textarea><button type=\"submit\" class=\"button form__submit\">Подключиться</button><div class=\"message\"><p class=\"message__text\"> Спасибо!<br> Мы приняли ваш запрос.<br><br> В ближайшее время наш специалист поддержки свяжется с вами.<br></p></div>", 5)
const _hoisted_9 = [
  _hoisted_4
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "connect__bottom" }, [
  /*#__PURE__*/_createElementVNode("span", null, "© 2020, Everypay "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "connect__politic",
    href: ""
  }, "Политика конфиденциальности ")
], -1)
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      onSubmit: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showMesage()), ["prevent"])),
      class: _normalizeClass(["connect__form form form-light", { 'form--submitted': _ctx.isSubmitted }])
    }, _hoisted_9, 34),
    _hoisted_10,
    _createElementVNode("img", {
      src: _ctx.IMAGE_BASE_URL + 'connect-lines.png',
      alt: "",
      class: "connect__lines"
    }, null, 8, _hoisted_11)
  ]))
}